import { useCallback, useEffect, useRef, useState } from "react";

export function useArticlePageScroll() {
  const heroBottomMarkerRef = useRef<HTMLDivElement | null>(null);
  const headerRef = useRef<HTMLDivElement | null>(null);
  const [isHeroOnScreen, setIsHeroOnScreen] = useState(true);

  const onPageScrollListen = useCallback(() => {
    const bottomMarkerY = heroBottomMarkerRef.current?.offsetTop ?? 0;
    const headerHeight = headerRef.current?.clientHeight ?? 0;
    setIsHeroOnScreen(window.scrollY < bottomMarkerY - headerHeight);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onPageScrollListen);
    return () => {
      window.removeEventListener("scroll", onPageScrollListen);
    };
  }, [onPageScrollListen]);

  return {
    heroBottomMarkerRef,
    headerRef,
    isHeroOnScreen,
  };
}
